import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions([
      'getDealerPlans',
      'getUserInfo',
      'login'
    ]),
    getUserAndPlans () {
      this.getUserInfo().then(success => {
        const { dealerId } = success
        this.getDealerPlans({ dealerId })
        this.$router.push({ path: '/home' })
      }).catch(err => {
        console.error(err)
        this.$router.push({ path: '/home' })
      })
    }
  }
}
